import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { InvitationModel } from 'src/models/invitationModel';
import { UtilisateurDataService } from 'src/services/utilisateur-data.service';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-detail-invitation-dialog',
    templateUrl: './detail-invitation-dialog.component.html',
    styleUrls: ['./detail-invitation-dialog.component.scss'],
    imports: [
        CommonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        TranslateModule
    ]
})
export class DetailInvitationDialogComponent implements OnInit {
  isLoading: boolean = true;
  invitation!: InvitationModel;
  constructor(public dialogRef: MatDialogRef<DetailInvitationDialogComponent>,
    private utilisateurService: UtilisateurService,
      @Inject(MAT_DIALOG_DATA) public data: { utilisateurId: number}) { }

  ngOnInit() {
    this.utilisateurService.ObtenirInvitation(this.data.utilisateurId).subscribe((res) => {
      this.invitation = res;
      this.isLoading = false;
    });
    this.dialogRef.updateSize('700px', '300px');
  }

   onClose(): void {
    this.dialogRef.close(false);
  }

}
